// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination .page-item .page-link{color:#797857}.pagination .page-item.active .page-link{background-color:#797857!important;border-color:#797857!important;color:#fff!important}.pagination .page-link:hover{background-color:#a09e78!important;border-color:#a09e78!important;color:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
